// extracted by mini-css-extract-plugin
export default {"WaveContainer":"Wave_WaveContainer__S4R+v","RegularColor":"Wave_RegularColor__3X4pX","InvertColor":"Wave_InvertColor__XuLeA"};